/* GENERATED — edit lib/, not this file.
 *
 * Built by scripts/build-theme-assets.mjs from:
 *   lib/formula.mjs
 *   theme/src/learn-blocks-ui.js
 *
 * The calculator formula engine below is the SAME code node --test runs
 * against, concatenated and wrapped in an IIFE because the theme has no
 * bundler. Editing it here will be overwritten and will fail `npm test`
 * (the staleness check).
 */
(function () {
  "use strict";

  var stkT = window.stkT || function (k, f) { return f; };
  function stkFill(s, vars) {
    return String(s).replace(/\{(\w+)\}/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(vars, k) ? String(vars[k]) : m;
    });
  }
  function stkRoot() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return r.charAt(r.length - 1) === "/" ? r : r + "/";
  }

  /* ---------- generated from lib/ ---------- */
  // Calculator formulas for `learn.blocks` calculator blocks (ARCHITECTURE.md §17.3).
  //
  // A tiny, sandboxed arithmetic language: numbers, identifiers, + - * / ^ %,
  // parentheses, unary minus and a fixed function set. Parsed to an AST and
  // evaluated by walking it — there is no `eval`, no `Function`, no property
  // access, so a formula typed into the admin can never reach the page. The same
  // file runs in node (validation in app/blocks.mjs and the tests) and in the
  // browser (theme/assets/learn-blocks.js inlines it via scripts/build-theme-assets.mjs
  // and public/ imports it as a module), so it must stay dependency-free ESM.
  //
  // Grammar (precedence low → high):
  //   expr    := term (("+" | "-") term)*
  //   term    := unary (("*" | "/" | "%") unary)*
  //   unary   := "-" unary | power
  //   power   := primary ("^" unary)?            (right-assoc)
  //   primary := number | ident | ident "(" args ")" | "(" expr ")"

  const FUNCTIONS = {
    min: (...a) => Math.min(...a),
    max: (...a) => Math.max(...a),
    round: (x, d = 0) => { const m = 10 ** d; return Math.round(x * m) / m; },
    floor: (x) => Math.floor(x),
    ceil: (x) => Math.ceil(x),
    abs: (x) => Math.abs(x),
    sqrt: (x) => Math.sqrt(x),
    clamp: (x, lo, hi) => Math.min(Math.max(x, lo), hi),
  };

  const FUNCTION_ARITY = { min: [1, Infinity], max: [1, Infinity], round: [1, 2], floor: [1, 1], ceil: [1, 1], abs: [1, 1], sqrt: [1, 1], clamp: [3, 3] };

  class FormulaError extends Error {
    constructor(message, pos) { super(message); this.name = "FormulaError"; this.pos = pos; }
  }

  function tokenise(src) {
    const s = String(src ?? "");
    const tokens = [];
    let i = 0;
    while (i < s.length) {
      const c = s[i];
      if (/\s/.test(c)) { i++; continue; }
      if (/[0-9.]/.test(c)) {
        const m = /^(\d+\.?\d*|\.\d+)/.exec(s.slice(i));
        if (!m || m[0] === ".") throw new FormulaError(`Bad number at ${i}`, i);
        tokens.push({ t: "num", v: Number(m[0]), pos: i });
        i += m[0].length; continue;
      }
      if (/[A-Za-z_]/.test(c)) {
        const m = /^[A-Za-z_][A-Za-z0-9_]*/.exec(s.slice(i));
        tokens.push({ t: "id", v: m[0], pos: i });
        i += m[0].length; continue;
      }
      if ("+-*/^%(),".includes(c)) { tokens.push({ t: c, pos: i }); i++; continue; }
      throw new FormulaError(`Unexpected character "${c}" at ${i}`, i);
    }
    tokens.push({ t: "eof", pos: s.length });
    return tokens;
  }

  function parse(src) {
    const toks = tokenise(src);
    let p = 0;
    const peek = () => toks[p];
    const next = () => toks[p++];
    const expect = (t) => { const k = next(); if (k.t !== t) throw new FormulaError(`Expected "${t}" at ${k.pos}`, k.pos); return k; };

    function expr() {
      let left = term();
      while (peek().t === "+" || peek().t === "-") { const op = next().t; left = { k: "bin", op, l: left, r: term() }; }
      return left;
    }
    function term() {
      let left = unary();
      while (peek().t === "*" || peek().t === "/" || peek().t === "%") { const op = next().t; left = { k: "bin", op, l: left, r: unary() }; }
      return left;
    }
    function unary() {
      if (peek().t === "-") { next(); return { k: "neg", e: unary() }; }
      return power();
    }
    function power() {
      const base = primary();
      if (peek().t === "^") { next(); return { k: "bin", op: "^", l: base, r: unary() }; }
      return base;
    }
    function primary() {
      const k = next();
      if (k.t === "num") return { k: "num", v: k.v };
      if (k.t === "id") {
        if (peek().t === "(") {
          next();
          const args = [];
          if (peek().t !== ")") { args.push(expr()); while (peek().t === ",") { next(); args.push(expr()); } }
          expect(")");
          if (!FUNCTIONS[k.v]) throw new FormulaError(`Unknown function "${k.v}"`, k.pos);
          const [lo, hi] = FUNCTION_ARITY[k.v];
          if (args.length < lo || args.length > hi) throw new FormulaError(`${k.v}() takes ${lo === hi ? lo : lo + "–" + (hi === Infinity ? "n" : hi)} argument${lo === 1 && hi === 1 ? "" : "s"}`, k.pos);
          return { k: "call", fn: k.v, args };
        }
        return { k: "var", name: k.v };
      }
      if (k.t === "(") { const e = expr(); expect(")"); return e; }
      if (k.t === "eof") throw new FormulaError("Unexpected end of formula", k.pos);
      throw new FormulaError(`Unexpected "${k.t}" at ${k.pos}`, k.pos);
    }

    const ast = expr();
    if (peek().t !== "eof") throw new FormulaError(`Unexpected "${peek().t}" at ${peek().pos}`, peek().pos);
    return ast;
  }

  // Every identifier the formula reads (so validation can check they exist).
  function variables(ast, out = new Set()) {
    if (!ast) return out;
    if (ast.k === "var") out.add(ast.name);
    if (ast.k === "bin") { variables(ast.l, out); variables(ast.r, out); }
    if (ast.k === "neg") variables(ast.e, out);
    if (ast.k === "call") ast.args.forEach((a) => variables(a, out));
    return out;
  }

  function evaluate(ast, vars = {}) {
    switch (ast.k) {
      case "num": return ast.v;
      case "var": {
        const v = vars[ast.name];
        if (v === undefined || v === null || v === "") return NaN;
        const n = Number(v);
        return Number.isFinite(n) ? n : NaN;
      }
      case "neg": return -evaluate(ast.e, vars);
      case "call": return FUNCTIONS[ast.fn](...ast.args.map((a) => evaluate(a, vars)));
      case "bin": {
        const l = evaluate(ast.l, vars), r = evaluate(ast.r, vars);
        switch (ast.op) {
          case "+": return l + r;
          case "-": return l - r;
          case "*": return l * r;
          case "/": return r === 0 ? NaN : l / r;
          case "%": return r === 0 ? NaN : l % r;
          case "^": return l ** r;
        }
      }
    }
    return NaN;
  }

  // Convenience: parse + evaluate. Throws FormulaError on a bad formula; returns
  // NaN (never throws) for missing inputs or division by zero, so a half-filled
  // calculator shows "—" rather than an error.
  function calc(src, vars = {}) {
    return evaluate(parse(src), vars);
  }

  // Validate one formula against the names it may use. Returns [] or a list of
  // human-readable problems (never throws) — the shape the block validator wants.
  function checkFormula(src, allowedNames = []) {
    const problems = [];
    if (!String(src ?? "").trim()) return ["Formula is empty"];
    let ast;
    try { ast = parse(src); } catch (e) { return [e.message]; }
    const allowed = new Set(allowedNames);
    for (const v of variables(ast)) if (!allowed.has(v)) problems.push(`Unknown name "${v}"`);
    return problems;
  }

  // UI half of theme/assets/learn-blocks.js — render + hydrate for `learn.blocks`
  // interactive content (ARCHITECTURE.md §17.3). A BODY FRAGMENT, not a
  // standalone script: scripts/build-theme-assets.mjs concatenates it after the
  // plain-scripted lib/formula.mjs, so `parse`, `evaluate`, `calc`, `checkFormula`,
  // `tokenise`, `variables`, `FUNCTIONS` and `FormulaError` are in scope here
  // without an import. Edit this file for anything render/UI; edit lib/formula.mjs
  // for anything about the calculator language. Never edit the generated output.
  //
  // render(block) is the JS TWIN of theme/snippets/learn-blocks.liquid — same
  // markup, same classes, same order, statement for statement, so the admin
  // preview (which loads this generated file as a classic script) shows exactly
  // what the storefront renders. Any change here must be mirrored there.
  /* ---------- UI (this file is the source; the formula engine above is generated) ---------- */

  var LEARN_BLOCKS_VERSION = "1.0.0";

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function nl2br(s) {
    return String(s == null ? "" : s).replace(/\n/g, "<br>");
  }

  function escJson(value) {
    return JSON.stringify(value).replace(/<\//g, "<\\/");
  }

  /* ---------- render: block -> markup (mirrors learn-blocks.liquid case block.type) ---------- */

  // {%- when 'quiz' -%}
  function renderQuiz(b) {
    var html = "";
    if (b.title) html += '<h3 class="learn-block__title">' + esc(b.title) + "</h3>";
    html += '<form class="learn-quiz" data-learn-quiz novalidate>';
    (b.questions || []).forEach(function (q, i) {
      html += '<fieldset class="learn-quiz__q" data-qid="' + esc(q.id) + '">';
      html += "<legend>" + (i + 1) + ". " + esc(q.text) + "</legend>";
      (q.options || []).forEach(function (o) {
        html += '<label class="learn-quiz__opt"><input type="radio" name="q_' + esc(q.id) + '" value="' + esc(o.id) + '"> <span>' + esc(o.text) + "</span></label>";
      });
      if (q.explanation) html += '<p class="learn-quiz__explain" hidden>' + esc(q.explanation) + "</p>";
      html += "</fieldset>";
    });
    html += '<footer class="learn-quiz__foot">';
    html += '<button type="submit" class="learn-btn learn-btn--primary" data-learn-quiz-submit>' + esc(stkT("stk.learn_blocks.quiz_submit", "Check answers")) + "</button>";
    html += '<p class="learn-quiz__result" aria-live="polite"></p>';
    html += "</footer>";
    html += "</form>";
    return html;
  }

  // {%- when 'checklist' -%}
  function renderChecklist(b) {
    var items = b.items || [];
    var html = "";
    if (b.title) html += '<h3 class="learn-block__title">' + esc(b.title) + "</h3>";
    html += '<div class="learn-checklist__head">';
    html += '<p class="learn-checklist__progress" aria-live="polite">' + esc(stkFill(stkT("stk.learn_blocks.checklist_progress_js", "{done} of {total} done"), { done: 0, total: items.length })) + "</p>";
    html += '<div class="learn-checklist__bar"><div class="learn-checklist__fill" style="width:0%"></div></div>';
    html += "</div>";
    html += '<ul class="learn-checklist" data-learn-checklist>';
    items.forEach(function (it) {
      html += '<li class="learn-checklist__item">';
      html += '<label><input type="checkbox" value="' + esc(it.id) + '"> <span>' + esc(it.text) + "</span></label>";
      if (it.detail) html += '<p class="learn-checklist__detail">' + esc(it.detail) + "</p>";
      html += "</li>";
    });
    html += "</ul>";
    html += '<button type="button" class="learn-btn learn-btn--small" data-learn-checklist-reset>' + esc(stkT("stk.learn_blocks.checklist_reset", "Reset")) + "</button>";
    return html;
  }

  // {%- when 'poll' -%}
  function renderPoll(b) {
    var type = b.multi ? "checkbox" : "radio";
    var html = "";
    html += '<p class="learn-poll__q">' + esc(b.question) + "</p>";
    html += '<form class="learn-poll" data-learn-poll>';
    html += '<div class="learn-poll__options">';
    (b.options || []).forEach(function (o) {
      html += '<label class="learn-poll__opt"><input type="' + type + '" name="poll_' + esc(b.id) + '" value="' + esc(o.id) + '"> <span>' + esc(o.text) + "</span></label>";
    });
    html += "</div>";
    html += '<button type="submit" class="learn-btn learn-btn--primary" data-learn-poll-vote>' + esc(stkT("stk.learn_blocks.poll_vote", "Vote")) + "</button>";
    html += "</form>";
    html += '<div class="learn-poll__results" data-learn-poll-results hidden></div>';
    return html;
  }

  // {%- when 'before_after' -%}
  function baImgAttrs(img) {
    var s = "";
    if (img && img.width) s += ' width="' + esc(img.width) + '"';
    if (img && img.height) s += ' height="' + esc(img.height) + '"';
    return s;
  }
  function renderBeforeAfter(b) {
    var before = b.before || {}, after = b.after || {};
    var pos = b.start != null ? b.start : 50;
    var html = '<figure class="learn-ba" data-learn-ba style="--pos:' + esc(pos) + '%">';
    html += '<div class="learn-ba__frame">';
    html += '<img class="learn-ba__after" src="' + esc(after.src) + '" alt="' + esc(after.alt) + '"' + baImgAttrs(after) + ' loading="lazy">';
    html += '<img class="learn-ba__before" src="' + esc(before.src) + '" alt="' + esc(before.alt) + '"' + baImgAttrs(before) + ' loading="lazy">';
    html += '<div class="learn-ba__divider" aria-hidden="true"></div>';
    html += "</div>";
    html += '<input type="range" class="learn-ba__range" min="0" max="100" value="' + esc(pos) + '" aria-label="' + esc(stkT("stk.learn_blocks.before_after_aria", "Compare before and after")) + '">';
    if (b.caption) html += "<figcaption>" + esc(b.caption) + "</figcaption>";
    html += "</figure>";
    return html;
  }

  // {%- when 'calculator' -%}
  function renderCalculator(b) {
    var html = "";
    if (b.title) html += '<h3 class="learn-block__title">' + esc(b.title) + "</h3>";
    html += '<form class="learn-calc" data-learn-calc>';
    html += '<div class="learn-calc__inputs">';
    (b.inputs || []).forEach(function (inp) {
      html += '<label class="learn-calc__input">';
      html += '<span class="learn-calc__label">' + esc(inp.label) + "</span>";
      html += '<span class="learn-calc__field">';
      html += '<input type="number" name="' + esc(inp.key) + '" value="' + (inp.default != null ? esc(inp.default) : "") + '"' +
        (inp.min != null ? ' min="' + esc(inp.min) + '"' : "") +
        (inp.max != null ? ' max="' + esc(inp.max) + '"' : "") +
        (inp.step != null ? ' step="' + esc(inp.step) + '"' : "") + ">";
      if (inp.unit) html += '<span class="learn-calc__unit">' + esc(inp.unit) + "</span>";
      html += "</span></label>";
    });
    html += "</div>";
    html += '<div class="learn-calc__outputs">';
    (b.outputs || []).forEach(function (out) {
      html += '<div class="learn-calc__output">';
      html += '<span class="learn-calc__out-label">' + esc(out.label) + "</span>";
      html += '<output class="learn-calc__out-value" name="' + esc(out.key) + '">–</output>';
      if (out.unit) html += '<span class="learn-calc__out-unit">' + esc(out.unit) + "</span>";
      html += "</div>";
    });
    html += "</div>";
    if (b.note) html += '<p class="learn-calc__note">' + esc(b.note) + "</p>";
    html += "</form>";
    return html;
  }

  // {%- when 'callout' -%}
  var CALLOUT_ICON = { info: "ℹ︎", tip: "💡", warning: "⚠︎", success: "✓" };
  function renderCallout(b) {
    var tone = b.tone || "info";
    var html = '<aside class="learn-callout learn-callout--' + esc(tone) + '" role="note">';
    html += '<span class="learn-callout__icon" aria-hidden="true">' + (CALLOUT_ICON[tone] || CALLOUT_ICON.info) + "</span>";
    html += '<div class="learn-callout__body">';
    if (b.title) html += '<p class="learn-callout__title">' + esc(b.title) + "</p>";
    html += '<p class="learn-callout__text">' + nl2br(esc(b.body)) + "</p>";
    html += "</div></aside>";
    return html;
  }

  // {%- when 'step' -%}
  function renderStep(b) {
    var html = '<div class="learn-step">';
    html += '<span class="learn-step__n" aria-hidden="true">' + esc(b.number != null ? b.number : "") + "</span>";
    html += '<div class="learn-step__body">';
    html += '<h3 class="learn-step__title">' + esc(b.title) + "</h3>";
    if (b.body) html += '<p class="learn-step__text">' + nl2br(esc(b.body)) + "</p>";
    if (b.image && b.image.src) {
      html += '<figure class="learn-step__figure"><img src="' + esc(b.image.src) + '" alt="' + esc(b.image.alt) + '" loading="lazy"></figure>';
    }
    html += "</div></div>";
    return html;
  }

  // {%- when 'materials' -%} — the JS twin has no storefront product data (no
  // all_products), so it renders an empty placeholder box where the Liquid
  // would show product.featured_image, and no price line.
  function renderMaterials(b) {
    var html = '<div class="learn-materials">';
    html += '<h3 class="learn-block__title">' + esc(b.title || stkT("stk.learn_blocks.materials_title_default", "What you need")) + "</h3>";
    html += '<ul class="learn-materials__list">';
    (b.items || []).forEach(function (it) {
      html += '<li class="learn-materials__item">';
      html += '<div class="learn-materials__img" aria-hidden="true"></div>';
      html += '<div class="learn-materials__info">';
      var title = esc(it.title || "");
      if (it.handle) html += '<p class="learn-materials__title"><a href="' + stkRoot() + "products/" + esc(it.handle) + '">' + title + "</a></p>";
      else html += '<p class="learn-materials__title">' + title + "</p>";
      if (it.note) html += '<p class="learn-materials__note">' + esc(it.note) + "</p>";
      html += "</div>";
      html += '<button type="button" class="learn-btn learn-btn--small" data-learn-add data-product-id="' + esc(it.product_id) + '">' + esc(stkT("stk.common.add", "Add")) + "</button>";
      html += "</li>";
    });
    html += "</ul></div>";
    return html;
  }

  // {%- when 'faq' -%}
  function faqJsonLd(b) {
    var items = b.items || [];
    if (!items.length) return "";
    var ld = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: items.map(function (it) {
        return { "@type": "Question", name: it.q, acceptedAnswer: { "@type": "Answer", text: it.a } };
      }),
    };
    return '<script type="application/ld+json">' + escJson(ld) + "</script>";
  }
  function renderFaq(b) {
    var html = '<div class="learn-faq">';
    if (b.title) html += '<h3 class="learn-block__title">' + esc(b.title) + "</h3>";
    (b.items || []).forEach(function (it) {
      html += '<details class="learn-faq__item"><summary>' + esc(it.q) + "</summary><div>" + esc(it.a) + "</div></details>";
    });
    html += "</div>";
    html += faqJsonLd(b);
    return html;
  }

  var BLOCK_RENDERERS = {
    quiz: renderQuiz,
    checklist: renderChecklist,
    poll: renderPoll,
    before_after: renderBeforeAfter,
    calculator: renderCalculator,
    callout: renderCallout,
    step: renderStep,
    materials: renderMaterials,
    faq: renderFaq,
  };

  function render(block) {
    if (!block || !block.type || !BLOCK_RENDERERS[block.type]) return "";
    var body = BLOCK_RENDERERS[block.type](block);
    var json = escJson(block);
    return '<section class="learn-block learn-block--' + esc(block.type) + '" data-learn-block data-block-id="' + esc(block.id) + '" data-block-type="' + esc(block.type) + '">' +
      '<script type="application/json" data-learn-block-json>' + json + "</script>" +
      body +
      "</section>";
  }

  function renderAll(blocks) {
    var list = Array.isArray(blocks) ? blocks : [];
    return '<div class="learn-blocks" data-learn-blocks>' + list.map(render).join("") + "</div>";
  }

  /* ---------- hydrate: behaviour, lazy via IntersectionObserver ---------- */

  function readJSON(key) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }
  function writeJSON(key, value) {
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* storage unavailable — behaviour still works, just isn't remembered */ }
  }
  function pct(score, total) { return total ? Math.round((score / total) * 100) : 0; }

  function dispatchLessonComplete(blockId) {
    var handle = document.body && document.body.dataset ? document.body.dataset.learnHandle || null : null;
    var detail = { blockId: blockId, articleHandle: handle };
    var evt;
    try { evt = new CustomEvent("learn:lesson-complete", { detail: detail }); }
    catch (e) { evt = document.createEvent("CustomEvent"); evt.initCustomEvent("learn:lesson-complete", true, true, detail); }
    document.dispatchEvent(evt);
  }

  function hydrateQuiz(node, block) {
    var form = node.querySelector("[data-learn-quiz]");
    if (!form) return;
    var resultEl = form.querySelector(".learn-quiz__result");
    var key = "learn:quiz:" + block.id;

    var saved = readJSON(key);
    if (saved && resultEl) {
      resultEl.textContent = stkFill(stkT("stk.learn_blocks.quiz_score_sentence", "You scored {score} of {total} ({percent}%). Pass mark {pass_mark}%."), { score: saved.score, total: saved.total, percent: pct(saved.score, saved.total), pass_mark: block.pass_mark });
      resultEl.classList.toggle("is-pass", !!saved.passed);
    }

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var score = 0;
      var questions = block.questions || [];
      questions.forEach(function (q) {
        var picked = form.querySelector('input[name="q_' + q.id + '"]:checked');
        var correct = (q.options || []).filter(function (o) { return o.correct; })[0];
        var isRight = !!(picked && correct && picked.value === correct.id);
        if (isRight) score++;
        var fieldset = form.querySelector('fieldset[data-qid="' + q.id + '"]');
        if (fieldset) {
          fieldset.classList.toggle("is-correct", isRight);
          fieldset.classList.toggle("is-incorrect", !isRight);
          var explain = fieldset.querySelector(".learn-quiz__explain");
          if (explain) explain.hidden = false;
        }
      });
      var total = questions.length;
      var percent = pct(score, total);
      var passed = percent >= (block.pass_mark || 0);
      if (resultEl) {
        resultEl.textContent = stkFill(stkT("stk.learn_blocks.quiz_score_sentence", "You scored {score} of {total} ({percent}%). Pass mark {pass_mark}%."), { score: score, total: total, percent: percent, pass_mark: block.pass_mark });
        resultEl.classList.toggle("is-pass", passed);
      }
      writeJSON(key, { score: score, total: total, passed: passed, at: Date.now() });
      if (passed && block.complete_lesson_on_pass) dispatchLessonComplete(block.id);
    });
  }

  function hydrateChecklist(node, block) {
    var list = node.querySelector("[data-learn-checklist]");
    if (!list) return;
    var progressEl = node.querySelector(".learn-checklist__progress");
    var fillEl = node.querySelector(".learn-checklist__fill");
    var resetBtn = node.querySelector("[data-learn-checklist-reset]");
    var key = "learn:checklist:" + block.id;
    var total = (block.items || []).length;
    var boxes = [].slice.call(list.querySelectorAll('input[type="checkbox"]'));

    function ticked() { return boxes.filter(function (c) { return c.checked; }).map(function (c) { return c.value; }); }
    function paint() {
      var done = ticked().length;
      if (progressEl) progressEl.textContent = stkFill(stkT("stk.learn_blocks.checklist_progress_js", "{done} of {total} done"), { done: done, total: total });
      if (fillEl) fillEl.style.width = (total ? Math.round((done / total) * 100) : 0) + "%";
    }

    var saved = readJSON(key);
    if (Array.isArray(saved)) boxes.forEach(function (c) { c.checked = saved.indexOf(c.value) !== -1; });
    paint();

    boxes.forEach(function (c) {
      c.addEventListener("change", function () { writeJSON(key, ticked()); paint(); });
    });
    if (resetBtn) {
      resetBtn.addEventListener("click", function () {
        boxes.forEach(function (c) { c.checked = false; });
        writeJSON(key, []);
        paint();
      });
    }
  }

  function pollBarsHtml(block, results, total, note) {
    var html = "";
    if (note) html += '<p class="learn-poll__note">' + esc(note) + "</p>";
    (block.options || []).forEach(function (o) {
      var count = (results && results[o.id]) || 0;
      var p = pct(count, total);
      html += '<div class="learn-poll__bar">' +
        '<span class="learn-poll__bar-label">' + esc(o.text) + "</span>" +
        '<span class="learn-poll__bar-track"><span class="learn-poll__bar-fill" style="width:' + p + '%"></span></span>' +
        '<span class="learn-poll__bar-count">' + esc(stkFill(stkT("stk.learn_blocks.poll_bar_votes", "{count} votes · {percent}%"), { count: count, percent: p })) + "</span>" +
        "</div>";
    });
    return html;
  }

  function hydratePoll(node, block) {
    var form = node.querySelector("[data-learn-poll]");
    var resultsEl = node.querySelector("[data-learn-poll-results]");
    if (!form || !resultsEl) return;
    var key = "learn:poll:" + block.id;

    function showResults(results, total, note) {
      resultsEl.innerHTML = pollBarsHtml(block, results, total, note);
      resultsEl.hidden = false;
      form.hidden = true;
    }

    var saved = readJSON(key);
    if (saved) showResults(saved.results, saved.total, null);

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var picked = [].slice.call(form.querySelectorAll("input:checked")).map(function (i) { return i.value; });
      if (!picked.length) return;
      var handle = document.body && document.body.dataset ? document.body.dataset.learnHandle || null : null;
      fetch("/apps/learn/poll", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ block_id: block.id, article_handle: handle, option_ids: picked }),
      })
        .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
        .then(function (data) {
          writeJSON(key, { results: data.results, total: data.total });
          showResults(data.results, data.total, null);
        })
        .catch(function () {
          showResults({}, 0, stkT("stk.learn_blocks.poll_unavailable", "Thanks. Results are unavailable right now."));
        });
    });
  }

  function hydrateBeforeAfter(node, block) {
    var fig = node.querySelector("[data-learn-ba]");
    var range = node.querySelector(".learn-ba__range");
    if (!fig || !range) return;
    range.addEventListener("input", function () { fig.style.setProperty("--pos", range.value + "%"); });
  }

  function hydrateCalculator(node, block) {
    var form = node.querySelector("[data-learn-calc]");
    if (!form) return;
    function recompute() {
      var vars = {};
      (block.inputs || []).forEach(function (inp) {
        var el = form.querySelector('input[name="' + inp.key + '"]');
        vars[inp.key] = el ? el.value : inp.default;
      });
      (block.outputs || []).forEach(function (out) {
        var el = form.querySelector('output[name="' + out.key + '"]');
        var value;
        try { value = calc(out.formula, vars); } catch (e) { value = NaN; }
        vars[out.key] = value;
        if (el) el.textContent = typeof value === "number" && isFinite(value) ? value.toFixed(out.decimals != null ? out.decimals : 2) : "–";
      });
    }
    form.addEventListener("input", recompute);
    recompute();
  }

  var HYDRATORS = {
    quiz: hydrateQuiz,
    checklist: hydrateChecklist,
    poll: hydratePoll,
    before_after: hydrateBeforeAfter,
    calculator: hydrateCalculator,
  };

  function hydrateOne(node) {
    if (node.getAttribute("data-hydrated") === "1") return;
    node.setAttribute("data-hydrated", "1");
    var scriptEl = node.querySelector('script[data-learn-block-json]');
    var block = null;
    try { block = JSON.parse(scriptEl ? scriptEl.textContent : "{}"); } catch (e) { block = null; }
    if (!block) return;
    var fn = HYDRATORS[block.type];
    if (fn) fn(node, block);
  }

  function supportsIO() { return typeof window !== "undefined" && "IntersectionObserver" in window; }

  function hydrate(root) {
    root = root || document;
    if (!root.querySelectorAll) return;
    var nodes = [].slice.call(root.querySelectorAll("[data-learn-block]"));
    nodes.forEach(function (node) {
      if (supportsIO()) {
        var io = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { hydrateOne(node); obs.unobserve(node); }
          });
        }, { rootMargin: "200px" });
        io.observe(node);
      } else {
        hydrateOne(node);
      }
    });
  }

  function bootLearnBlocks() { hydrate(document); }
  if (!window.LearnBlocksNoAuto) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bootLearnBlocks);
    else bootLearnBlocks();
  }

  window.LearnBlocks = { render: render, renderAll: renderAll, hydrate: hydrate, VERSION: LEARN_BLOCKS_VERSION };
})();
